import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { Ndg } from 'src/app/model/ndg';
import { SurveyService } from '../../../service/survey.service';
import { MessageService } from 'src/app/service/message.service';
import { SurveyNdgDataFisRequest } from 'src/app/model/survey-request';
import { SurveyNewIdResponse, SurveyNdgDataResponse } from 'src/app/model/survey-response';
import { NdgDataEmit } from 'src/app/model/survey-emits';

@Component({
  selector: 'ndg-data-fis',
  templateUrl: './ndg-data-fis.component.html'
})
export class NdgDataFisComponent implements OnChanges {
  @Input() ndg!: Ndg;
  @Input() ndgData?: SurveyNdgDataResponse;
  @Output() complete = new EventEmitter<NdgDataEmit>();

  ndgForm!: FormGroup;
  completed: boolean = false;
  loading: boolean = false;

  constructor(
    private surveyService: SurveyService,
    private messageService: MessageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    // Check if the ndg (new survey) or ndgData (show survey) inputs have changed
    if((changes['ndg'] && changes['ndg'].firstChange) || changes['ndgData']) {
      this.init();
    }
  }

  init(): void {
    this.ndgForm = new FormGroup({
      type: new FormControl({value: this.ndg.typology, disabled: true}),

      occupation: new FormControl(this.ndgData?.occupation, Validators.required),
      graduation: new FormControl(this.ndgData?.graduation, Validators.required),
      familySize: new FormControl(this.ndgData?.familySize, Validators.required),
      maritalStatus: new FormControl(this.ndgData?.maritalStatus, Validators.required),
      financialHeritage: new FormControl(this.ndgData?.financialHeritage || 0, Validators.required),
      averageIncome: new FormControl(this.ndgData?.averageIncome || 0, Validators.required),
      otherInsured: new FormControl(this.ndgData?.otherInsured, Validators.required)
    });
    
    // Check if the form is in insert mode or not
    if(!this.isInsert()) {
      this.completed = true;
      this.ndgForm.disable();
    }
  }

  isInsert(): boolean {
    return this.ndgData === undefined;
  }

  get type() { return this.ndgForm.get('type'); }
  get occupation() { return this.ndgForm.get('occupation'); }
  get graduation() { return this.ndgForm.get('graduation'); }
  get familySize() { return this.ndgForm.get('familySize'); }
  get maritalStatus() { return this.ndgForm.get('maritalStatus'); }
  get financialHeritage() { return this.ndgForm.get('financialHeritage'); }
  get averageIncome() { return this.ndgForm.get('averageIncome'); }
  get otherInsured() { return this.ndgForm.get('otherInsured'); }

  hasError(field: AbstractControl | null) {
    return !!field && field.touched && !field.disabled && !field.valid;
  }

  onSubmit() {
    if(!this.ndgForm.valid || this.completed) {
      this.ndgForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.completed = true;

    const payload: SurveyNdgDataFisRequest = {
      ndgId: this.ndg.ndg,
      occupation: this.occupation?.value,
      graduation: this.graduation?.value,
      familySize: this.familySize?.value,
      maritalStatus: this.maritalStatus?.value,
      otherInsured: this.otherInsured?.value,
      financialHeritage: this.financialHeritage?.value,
      averageIncome: this.averageIncome?.value
    };

    this.surveyService.insertNdgDataFis(payload).subscribe({
      next: (surveyId: SurveyNewIdResponse) => {
        this.complete.emit({
          surveyId: surveyId.id,
          occupation: this.occupation?.value,
          averageIncome: this.averageIncome?.value,
          financialHeritage: this.financialHeritage?.value,
        });
        this.loading = false;
      },
      error: () => {
        this.messageService.error('survey.new.message.unknown-error');

        this.loading = false;
        this.completed = false;
      }
    });
  }
}
